module.exports = __webpack_public_path__ + "static/media/no-product-photo.73fc13e2.png";